; (function () {
    var
        _$wrapper = null,
        _report_id = null,
        _mousedown = false,
        _mousedownRow,
        _mousedownRowNumber = 0,

        init = function () {
            _$wrapper = $('.layout-word-export');
            if (_$wrapper.length > 0) {
                _report_id = _$wrapper.find('#hdnReportID').val();
                console.log('_report_id:', _report_id);
                $('#image-loading').hide();

                setupMouseDragging();
                setupBreakLineInsert();
                setupBreakLineRemove();
                setupBreakLineRemoveAll();
                setupDropdownItemSelected();
                setupTemplateSelect();
            }
        },
        setupDropdownItemSelected = function () {
            console.log('Setting up dropdown item selection...');
            $('.orientation-dropdown').on('click', '.dropdown-item', function (event) {
                console.log('Dropdown item clicked:', this);
                $(this).parent().siblings().find('.dropdown-item').removeClass('item-selected');
                $(this).addClass('item-selected');
                update();
            });
        },
        setupMouseDragging = function () {
            console.log('Setting up mouse dragging...');
            var rows = document.querySelectorAll('#formatting-table tr');
            console.log('Rows found:', rows.length);

            rows.forEach(function (row) {
                row.addEventListener('mousedown', function (event) {
                    console.log('Row mousedown event', row);
                    var hasHighlightedClass = row.classList.contains('format-user-page-break');
                    event.preventDefault();

                    if (hasHighlightedClass) {
                        console.log('Row has "format-user-page-break" class');
                        $('#formatting-table tr').addClass('add-break-line-mode');
                        _mousedown = true;
                        if (!_mousedownRow) {
                            _mousedownRow = row;
                            _mousedownRowNumber = row.getAttribute('data-line-index');
                            console.log('Mouse down row number:', _mousedownRowNumber);
                        }
                    } else {
                        console.log('Selecting a row without "format-user-page-break" class');
                        $('.format-pre-selected-page-break').removeClass('format-pre-selected-page-break');
                        row.classList.add('format-pre-selected-page-break');
                        _mousedown = false;
                    }
                });
            });

            rows.forEach(function (row) {
                row.addEventListener('mouseup', function (event) {
                    console.log('Row mouseup event', row);
                    if (_mousedown) {
                        console.log('Dragging ended');
                        _mousedownRow.classList.remove('format-user-page-break');
                        row.classList.add('format-user-page-break');
                        $('#formatting-table tr').removeClass('add-break-line-mode');
                        _mousedown = false;
                        _mousedownRow = null;
                        if (_mousedownRowNumber != row.getAttribute('data-line-index')) {
                            console.log('Row updated:', row.getAttribute('data-line-index'));
                            update();
                        }
                    }
                    if (_mousedownRowNumber === row.getAttribute('data-line-index')) {
                        console.log('Row selected for deletion');
                        row.classList.add('format-pre-selected-page-break');
                    }
                });
            });
        },
        setupBreakLineInsert = function () {
            console.log('Setting up break line insert...');
            _$wrapper.on('click', '.format-break-insert-page-break', function () {
                console.log('Inserting page break');
                $('.format-pre-selected-page-break').addClass('format-user-page-break').removeClass('format-pre-selected-page-break');
                update();
            });
        },
        setupBreakLineRemove = function () {
            console.log('Setting up break line remove...');
            _$wrapper.on('click', '.format-break-remove-page-break', function () {
                console.log('Removing page break');
                $('.format-pre-selected-page-break').removeClass('format-user-page-break').removeClass('format-pre-selected-page-break');
                update();
            });
        },
        setupBreakLineRemoveAll = function () {
            console.log('Setting up break line remove all...');
            _$wrapper.on('click', '.format-break-reset-all-page-break', function () {
                console.log('Removing all page breaks');
                $('.format-user-page-break').removeClass('format-user-page-break');
                update();
            });
        },

        setupTemplateSelect = function () {
            $("#TemplateID").on("change", function () {
                console.log('TemplateID changed');
                update();
            });
        }

    update = function () {
        console.log('Update called');
        var formData = new FormData();
        formData.append('ReportID', $('#hdnReportID').val());

        var $orientation = $('.orientation-dropdown .item-selected');
        console.log('Selected orientation:', $orientation.data('value'));
        formData.append($orientation.attr('name'), $orientation.data('value'));

        var rowsWithPageBreakClass = $('#formatting-table .format-user-page-break');
        console.log('Rows with page break class:', rowsWithPageBreakClass.length);

        var $pageBreakDisabled = $('#PageBreakAutomatic');
        var pageBreakDisabledValue = $pageBreakDisabled.is(':checkbox') ? $pageBreakDisabled.is(':checked') : $pageBreakDisabled.val();
        console.log('Page break disabled value:', pageBreakDisabledValue);
        formData.append($pageBreakDisabled.attr('name'), pageBreakDisabledValue);

        var $templateid = $('#TemplateID');
        var selectedTemplateID = $templateid.val();
        formData.append($templateid.attr('name'), selectedTemplateID);


        rowsWithPageBreakClass.each(function () {
            var dataLineIndex = $(this).data('line-index');
            console.log('Page break line index:', dataLineIndex);
            formData.append('PageBreaks', dataLineIndex);
        });

        $('#image-loading').show();

        console.log('postFormData');
        delta.ajax.postFormData(
            '/formatword/Update',
            formData,
            function (result2) {
                console.log('Update result:', result2);
                if (result2.isValid) {
                    var link = result2.url;
                    console.log('Redirecting to:', link);
                    window.location = link;
                } else {
                    $('#image-loading').hide();
                }
            }
        );
    },
        dummy = function () { };

    $(document).ready(init);
})();
